import { createFileRoute } from '@tanstack/react-router';
import { UserPage } from '@/pages/Users';

export const Route = createFileRoute('/_auth/users')({
  component: UserPage,
});
